import React from "react";
import ContactMe from "../Shared/Header/ContactMe/ContactMe";
import Header from "../Shared/Header/Header";
import About from "./AboutMe/About/About";
import Footer from "./Footer/Footer.";
import Projects from "./Projects/Projects";
import TechStack from "./TechStack/TechStack";
const Home = () => {
  return (
    <div>
      <Header></Header>
      <About></About>
      <TechStack></TechStack>
      <Projects />
      
      <ContactMe></ContactMe>
    <Footer></Footer>
    </div>
  );
};

export default Home;
//  {
//     "id": "07",
//     "name": "LA REVE Fashion",
//     "img": "https://i.ibb.co/FHPSHjh/la-reve-fashion.png",
//     "img1": "https://i.postimg.cc/T1G7HctW/la-reve-fashion-1.png",
//     "tech1": "JavaScript",
//     "tech5": "HTML",
//     "tech6": "CSS",
//     "projectType": "Single Page Web Application",
//     "category": "Man collection",
//     "pO1": "● It's a Website about Man collection where users can buy collection from different collection ",
//     "pO2": "● This is a modern single page application with JavaScript ",
//     "pO3": "● users can see their total collection and total price",
//     "liveSite": "https://la-reve-fashion.netlify.app/",
//     "clientSide": "https://github.com/JannatulHappy/la-reve-fashion",
//     "img2": "https://i.postimg.cc/rFM3hqHY/la-reve-fashio-2.png",
//     "img3": "https://i.ibb.co/xHvjr13/la-reve-3.png"
//   }